import React from 'react';
import InputUserSearch from './InputUserSearch';

class InputSearchUserDropdown extends React.Component {
  render() {
    const { field, label, col, nullOption } = this.props;

    return (
      <InputUserSearch
        col={col}
        label={label}
        field={field}
        nullOption={nullOption}
      />
    );
  }
}

export default InputSearchUserDropdown;
